export default {
  namespaced: true,
  state: {
    IssueRelations: [
      { key: 'CLONES', name: 'CLONES' },
      { key: 'IS_CLONED_BY', name: 'IS CLONED BY' },
      { key: 'BLOCKS', name: 'BLOCKS' },
      { key: 'IS_BLOCKS_BY', name: 'IS BLOCKS BY' },
      { key: 'DUPLICATES', name: 'DUPLICATES' },
      { key: 'IS_DUPLICATES_BY', name: 'IS DUPLICATES BY' },
      { key: 'RELATES_TO', name: 'RELATES TO' }
    ]
  },
  mutations: {
    SET_DICT() {}
  },
  actions: {}
};
